import React from 'react';
import type { MdComponentIndexProps } from '../type';
import type { SupportIconProps } from './SupportIconPropsNode';
import SupportIconPropsNode from './SupportIconPropsNode';

export function MarkdownIcon({
  icon,
  size,
  color,
  ...rest
}: {
  icon: SupportIconProps['icon'];
  size: SupportIconProps['iconSize'];
  color: SupportIconProps['iconColor'];
  className?: string;
  style?: React.CSSProperties;
} & MdComponentIndexProps) {
  if (!icon) return null;
  return (
    <SupportIconPropsNode icon={icon} iconSize={size} iconColor={color || 'primary'} {...rest} />
  );
}

MarkdownIcon.attributes = ['icon', 'size', 'color'] as string[];
MarkdownIcon.displayName = 'MarkdownIcon';
MarkdownIcon.inline = true;
